import React from 'react'
import PageLayout from '../pagelayout';
import LazyImg from '../lazyimg';

export const HowToLayout = ({title, images}) => {
    return (
        <PageLayout fullWidth bgWhite pad={false} headerbg={'#feec6b'}>
            <div className="container">
                <div className="flex-center">
                    <h1 className="m-t-30 m-b-45 f-54 f-600 header-underline">How To Use {title} App</h1>
                </div>
                <div className="container m-b-45">
                    <div className="row">
                        {
                            images.map(x => 
                                <div className="col-md-3 m-b-20 p-t-10">
                                    <LazyImg className="img-responsive" src={x} alt=""/>
                                </div>    
                            )
                        }
                    </div>
                </div>
            </div>
        </PageLayout>        
    )
}

let images = [];

for(let i = 1; i < 7; i++){
    images.push( require(`../../assets/how/customer/${i}.png`) );
}

export const HowToCustomer = () => (
    <HowToLayout title="Customer" images={images} />
)

export const HowToStore = () => (
    <HowToLayout title="Store" images={images} />
)

export const HowToDelivery = () => (
    <HowToLayout title="Delivery" images={images} />
)
